import Modal from '~/javascripts/components/Modal';
import ShareIcons from '~/javascripts/components/ShareIcons';

const ShareModal = ({
  defaultSocialShareContent,
  footerContent,
  headerText,
  modalId,
  shareUrl,
  subheaderText,
}) => (
  <Modal
    containerClassName={`${modalId} theme-maji text-center`}
    modalId={modalId}
    modalInnerClassName='md-rounded-lg px-0 md-px-3'
    ref={(el) => (window.modal.instances[`#${modalId}`] = el)}
  >
    <h1
      className='h40 text-kazimir font-normal pt-3 py-1'
      dangerouslySetInnerHTML={{ __html: headerText }}
    />
    <p
      className='p30 pb-3'
      dangerouslySetInnerHTML={{ __html: subheaderText }}
    />
    <ShareIcons
      defaultSocialShareContent={defaultSocialShareContent}
      shareUrl={shareUrl}
    />
    {footerContent && (
      <div className='modal-footer bg-cw-white dashed-line flex-row justify-center py-3 rounded-lg rounded-t-none border-none'>
        {footerContent}
      </div>
    )}
  </Modal>
);

export default ShareModal;
